/**
 * OrderCommunications — Communication tab on Order Detail page
 *
 * Shows a timeline of order-related communications (demo data).
 * In production, this would pull from Salesforce case/comment records.
 */

const DEMO_COMMS = [
  {
    id: 1,
    date: '2026-05-22T14:00:00Z',
    author: 'Sandvik Support',
    type: 'note',
    message: 'Order has been confirmed and is being prepared for shipment. Expected dispatch within 3 business days.',
  },
  {
    id: 2,
    date: '2026-05-20T09:30:00Z',
    author: 'Jean-Marc Beaulieu',
    type: 'customer',
    message: 'Please confirm estimated delivery date for this order. We need the items on-site by end of month.',
  },
  {
    id: 3,
    date: '2026-05-20T08:45:00Z',
    author: 'System',
    type: 'system',
    message: 'Order P007963 created successfully.',
  },
];

function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
  }) + ' ' + d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

export default function OrderCommunications() {
  return (
    <div className="py-4">
      <div className="space-y-4">
        {DEMO_COMMS.map(comm => (
          <div key={comm.id} className="flex gap-4">
            {/* Timeline dot + line */}
            <div className="flex flex-col items-center">
              <div className={`w-2.5 h-2.5 flex-shrink-0 mt-1.5 ${
                comm.type === 'customer' ? 'bg-electric-blue' :
                comm.type === 'system' ? 'bg-n3' : 'bg-vibrant-orange'
              }`} />
              <div className="w-px flex-1 bg-n2 mt-1" />
            </div>
            {/* Content */}
            <div className="pb-4 flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-normal text-carbon-black">{comm.author}</span>
                <span className="text-xs text-n5">{formatDateTime(comm.date)}</span>
              </div>
              <p className="text-sm text-n5">{comm.message}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Empty state if no comms */}
      {DEMO_COMMS.length === 0 && (
        <div className="text-center py-8">
          <span className="material-symbols-outlined text-3xl text-n3 mb-2 block">forum</span>
          <p className="text-sm text-n5">No communications for this order.</p>
        </div>
      )}
    </div>
  );
}
